{
  "reprint": {
    "printFailed": "Printing failed"
  },
  "resend": {
    "title": "Resend",
    "statement": "Resend the {{template}} message to {{phone}}"
  },
  "edit": {
    "title": "Edit deposit",
    "description": "This edit requires an edit reason, and is recorded in the edit history.",
    "attachmentLabel": "Supporting attachment",
    "attachmentOptional": "Optional",
    "attachmentHint": "PDF, JPEG or PNG, up to 5 MB",
    "attachmentTooLarge": "The attachment is larger than 5 MB",
    "attachmentTypeInvalid": "This attachment type is not allowed",
    "substantiveFields": "Amount, currency, a party's identity and the intended recipient are substantive.",
    "substantiveNotice": "A substantive edit marks the earlier signature as signed on an earlier version.",
    "sections": {
      "amountCurrency": "Amount and currency",
      "depositor": "Depositor",
      "intendedRecipient": "Intended recipient",
      "actualRecipient": "Actual recipient"
    },
    "removeIntended": "Remove the intended recipient",
    "noChangesYet": "No field has changed yet",
    "resignOffer": {
      "title": "Resend to tablet",
      "description": "This is a substantive edit. The deposit can be sent to the tablet for a new depositor signature.",
      "skip": "Skip"
    },
    "chooseAttachment": "Choose file",
    "noAttachment": "No file chosen"
  },
  "referralReview": {
    "title": "Review referral",
    "employeeNote": "Employee note",
    "referredBy": "Referred by",
    "recordedRecipient": "Recorded recipient data",
    "signature": "Recorded signature",
    "decisionRequired": "A decision is required",
    "noteRequired": "A note is required"
  },
  "cancel": {
    "title": "Cancel deposit",
    "statement": "Cancel deposit {{number}}, amount {{amount}}, depositor {{name}}",
    "reasonLabel": "Cancel reason",
    "confirmNoCashHeld": "No cash is held for this deposit",
    "returnHint": "If the cash was actually received, the correct action is returning it to the depositor."
  }
}
